/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AlertsService } from './services/AlertsService';
import { ApplicationsService } from './services/ApplicationsService';
import { CarsService } from './services/CarsService';
import { ClustersService } from './services/ClustersService';
import { ContractsService } from './services/ContractsService';
import { DriverObservationsService } from './services/DriverObservationsService';
import { EventsService } from './services/EventsService';
import { HlsService } from './services/HlsService';
import { InternalService } from './services/InternalService';
import { MosaicsService } from './services/MosaicsService';
import { SessionsService } from './services/SessionsService';
import { StatisticsService } from './services/StatisticsService';
import { SwitchesConnectionsService } from './services/SwitchesConnectionsService';
import { SwitchesDestinationsService } from './services/SwitchesDestinationsService';
import { SwitchesSourcesService } from './services/SwitchesSourcesService';
import { UsersService } from './services/UsersService';
import { VersionService } from './services/VersionService';
import { VodService } from './services/VodService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class ApiClient {
    public readonly alerts: AlertsService;
    public readonly applications: ApplicationsService;
    public readonly cars: CarsService;
    public readonly clusters: ClustersService;
    public readonly contracts: ContractsService;
    public readonly driverObservations: DriverObservationsService;
    public readonly events: EventsService;
    public readonly hls: HlsService;
    public readonly internal: InternalService;
    public readonly mosaics: MosaicsService;
    public readonly sessions: SessionsService;
    public readonly statistics: StatisticsService;
    public readonly switchesConnections: SwitchesConnectionsService;
    public readonly switchesDestinations: SwitchesDestinationsService;
    public readonly switchesSources: SwitchesSourcesService;
    public readonly users: UsersService;
    public readonly version: VersionService;
    public readonly vod: VodService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.alerts = new AlertsService(this.request);
        this.applications = new ApplicationsService(this.request);
        this.cars = new CarsService(this.request);
        this.clusters = new ClustersService(this.request);
        this.contracts = new ContractsService(this.request);
        this.driverObservations = new DriverObservationsService(this.request);
        this.events = new EventsService(this.request);
        this.hls = new HlsService(this.request);
        this.internal = new InternalService(this.request);
        this.mosaics = new MosaicsService(this.request);
        this.sessions = new SessionsService(this.request);
        this.statistics = new StatisticsService(this.request);
        this.switchesConnections = new SwitchesConnectionsService(this.request);
        this.switchesDestinations = new SwitchesDestinationsService(this.request);
        this.switchesSources = new SwitchesSourcesService(this.request);
        this.users = new UsersService(this.request);
        this.version = new VersionService(this.request);
        this.vod = new VodService(this.request);
    }
}

